let lastBottomScrollCompare = 0;

export default {
    mounted() {
        window.addEventListener(
            'scroll',
            () => {
                const scrollHeight = [
                    document.scrollingElement.scrollHeight,
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                ].sort((a, b) => {
                    return b - a;
                })[0];

                const compare = window.innerHeight + window.scrollY + 2;

                if (compare > lastBottomScrollCompare) {
                    const atEnd = compare >= scrollHeight;
                    if (atEnd) {
                        this.$bus.$emit('bottom-scroll');
                    }
                }

                lastBottomScrollCompare = compare;
            },
            { passive: true }
        );
    },
};
